import "core-js/modules/es.array.push.js";
import { defineComponent, ref, computed, watch, toRefs } from "vue";
import tips from "@/assets/tips.json";
import { upload } from "@/service/canvas";
import { DRAW_SIZES } from "@/common/constant";
import AiUploadImg from "@/components/AiUploadImg";
export default defineComponent({
  name: "setting-bar",
  components: {
    AiUploadImg
  },
  props: {
    ratio: {
      type: String
    },
    keywords: {
      type: String
    },
    img_urls: {
      type: String
    }
  },
  emit: ["update:ratio", "update:keywords", "update:img_urls"],
  setup(props, {
    emit
  }) {
    const {
      img_urls
    } = toRefs(props);
    const inputFile = ref(null);
    const uploadFile = () => {
      inputFile.value.click();
    };
    const uploadLoading = ref(false);
    const uploadImgs = ref([]);
    watch(img_urls, v => {
      if (!v) {
        uploadImgs.value = [];
      }
    });
    const changeFile = e => {
      let formData = new FormData();
      let file = e.target.files[0];
      formData.append("file", file);
      uploadLoading.value = true;
      upload(formData).then(res => {
        if (!res.errno) {
          uploadImgs.value.push(res.data);
          emit("addImages", uploadImgs.value.join(" "));
          emit("update:img_urls", uploadImgs.value.join(" "));
        }
      }).finally(() => {
        uploadLoading.value = false;
      });
      inputFile.value.value = "";
    };

    // 尺寸索引
    const ratioIndex = ref(-1);
    const wr = ref(0);
    const hr = ref(0);

    // 点选的提示关键词
    const selectedKeywords = ref([]);
    watch([wr, hr, ratioIndex], newv => {
      if (ratioIndex.value >= 0) {
        const [w, h, rindex] = newv;
        let ratio = "";
        if (rindex === DRAW_SIZES.length - 1) {
          ratio = `${w}:${h}`;
        } else {
          ratio = DRAW_SIZES[rindex].value;
        }
        emit("update:ratio", ratio);
      }
    }, {
      immediate: true
    });

    // 提示类型
    const tipTypes = ref([]);
    for (const tip in tips) {
      tipTypes.value.push(tip);
    }
    // 选中的提示类型
    const activeTipType = ref(tipTypes.value[0]);

    // 树结构
    const treeData = computed(() => {
      const data = tips[activeTipType.value];
      const root = [];
      for (const rootKey in data) {
        const children = data[rootKey];
        root.push({
          label: rootKey,
          children: children.map(item => {
            return {
              ...item,
              label: item.text
            };
          })
        });
      }
      return root;
    });
    return {
      changeFile,
      uploadImgs,
      wr,
      hr,
      DRAW_SIZES,
      tipTypes,
      activeTipType,
      treeData,
      ratioIndex,
      selectedKeywords,
      inputFile,
      uploadLoading,
      defaultProps: {
        children: "children",
        label: "label"
      },
      clickNode(node) {
        const key = node.label;
        const isLeaf = !node.children;
        if (isLeaf && selectedKeywords.value.indexOf(key) === -1) {
          selectedKeywords.value.push(key);
          emit("changeKeywords", selectedKeywords.value);
          emit("update:keywords", key);
        }
      },
      uploadFile,
      removeImg(del) {
        uploadImgs.value = uploadImgs.value.filter(item => item !== del);
      }
    };
  }
});